<template>
  <!--订单详情页面-->
  <tk-container
    :status="status"
    :probeType="3"
    hide-status-bar
    class="order-detail-bg"
    :style="`background-image: url(${orderImage}) !important`"
    @refresh="getInit"
    @scroll="watchScroll"
  >
    <!--头部-->
    <gradient-header slot="header" :is-show-back="true" :is-header-color="isHeaderColor" :back-style="false" :icon-name="'fanhui'"></gradient-header>
    <!--背景图片渲染-->
    <div class="content-box">
      <div class="m-l-12 font-20 font-bold text-white"
           v-if="orderDetail && orderDetail.status">
        {{orderStatus(orderDetail.status)}}
      </div>
      <!--订单地址-->
      <div class="m-x-12 m-t-10">
        <tk-card
          :height="55"
          :width="100"
          class="p-y-10"
          :is-middle="true"
        >
          <div class="tk-grid-2">
            <tk-avatar size="25" color="#FCA527">
              <tk-icon size="15" color="#fff">dizhi</tk-icon>
            </tk-avatar>
          </div>
          <div class="tk-grid-9" v-if="orderDetail && orderDetail.shippingAddress">
            <tk-flex middle class="font-18 font-bold full-width">
              <div>{{orderDetail.shippingAddress.name}}</div>
              <div class="m-l-10">{{orderDetail.shippingAddress.phone}}</div>
            </tk-flex>
            <div class="font-14 primary-gray m-t-5">
              {{$tkRegions.getFullName(orderDetail.shippingAddress.region) +
              orderDetail.shippingAddress.address}}
            </div>
          </div>
        </tk-card>
      </div>
    </div>
    <!--购买的商品-->
    <div class="m-x-12 m-t-10">
      <card
        :width="100" :height="50"
        v-if="orderDetail && orderDetail.commodityData
         && orderDetail.commodityData.length"
        class="p-t-8"
      >
        <order-commodity-data :order-type="$route.query.type" :order-detail="orderDetail"></order-commodity-data>
      </card>
    </div>
    <!--评价数据-->
    <div class="m-x-12 m-t-10 font-14" v-if="orderEvaluationRecords">
      <tk-card
        :height="50" :width="100"
        is-middle
        is-column
        class="p-t-8 p-b-0 p-x-0"
      >
        <!--评价信息-->
        <div class="p-x-12 p-b-8 full-width">
          <tk-flex middle between class="full-width">
            <div class="font-14">产品评价</div>
            <van-rate readonly v-model="orderEvaluationRecords.orderAltered"
                      size="17" allow-half
                      void-icon="star" color="#fdac23"
            />
          </tk-flex>
          <tk-flex middle between class="full-width m-t-8">
            <div class="font-14">服务评价</div>
            <van-rate readonly v-model="orderEvaluationRecords.serviceAltered"
                      size="17" allow-half color="#fdac23"
                      void-icon="star"
            />
          </tk-flex>
          <tk-flex middle between class="full-width m-t-8">
            <div class="font-14">物流评价</div>
            <van-rate readonly v-model="orderEvaluationRecords.logisticsAltered"
                      size="17" allow-half color="#fdac23"
                      void-icon="star"
            />
          </tk-flex>
          <div class="m-t-8 font-14 text-gray">
            {{orderEvaluationRecords.commentContent}}
          </div>
          <three-image-post
            v-if="orderEvaluationRecords.pictureCombination"
            :image-arr="orderEvaluationRecords.pictureCombination"
            :sign-width="60"
            :class="{ 'm-t-8': orderEvaluationRecords.pictureCombination &&
             orderEvaluationRecords.pictureCombination.length }"
            class="p-x-0"
          ></three-image-post>
        </div>
        <!--评论内容-->
        <div
          class="posts-card-footer p-t-8 full-width"
          v-if="orderEvaluationRecords.reviewsPostsList &&
           orderEvaluationRecords.reviewsPostsList.length"
        >
          <div
            class="full-width p-x-12"
            :class="{ 'posts-card-footer-bottom-active': isShowTouch &&
                       deleteRender.index === index && Object.keys(deleteRender.data).length,
                       'posts-card-footer-bottom-radius': index === (orderEvaluationRecords.reviewsPostsList.length - 1),
                       'p-b-8': index === (orderEvaluationRecords.reviewsPostsList.length - 1),
                       'p-t-5': index > 0 }"
            v-for="(m, index) in orderEvaluationRecords.reviewsPostsList"
            @touchstart="gtouchstart($event, m.reviewer, m, index)"
            @touchmove="gtouchmove()"
            @touchend="gtouchend(m.reviewer, m, index)"
            :key="`specifiedReplyData${index}`"
          >
            <!--头像与时间-->
            <tk-flex
              between
              middle
              class="full-width"
            >
              <tk-flex
                column
                middle
              >
                <div class="font-14 font-bold">{{m.reviewer.name ? m.reviewer.name : '用户'}}</div>
              </tk-flex>
              <div class="caption" style="font-size: 14px !important;">{{$tkDate(m.date).fromNow()}}</div>
            </tk-flex>
            <!--内容详情-->
            <div
              class="font-14 text-light-grey"
            >
              {{m.reviewerContent}}
            </div>
          </div>
        </div>
      </tk-card>
    </div>
    <!--退换货数据-->
    <div class="m-x-12 m-t-10 font-14" v-if="returnExchangeRecords">
      <tk-card :width="100" :height="50" is-middle class="p-y-8">
        <tk-flex middle between class="full-width">
          <div>申请状态</div>
          <div class="primary">{{returnExchangeRecords.status | returnExchangeApply}}</div>
        </tk-flex>
        <tk-flex
          middle
          between class="full-width m-t-10"
          v-if="returnExchangeRecords.type"
        >
          <div>申请类型</div>
          <div>{{returnExchangeRecords.type | returnExchangeText}}</div>
        </tk-flex>
        <tk-flex column class="full-width m-t-10">
          <div class="font-14 font-bold">问题描述</div>
          <div class="caption m-t-10" style="font-size: 14px !important;">{{returnExchangeRecords.detailedReason}}</div>
        </tk-flex>
        <three-image-post
          v-if="returnExchangeRecords.pictureCombination"
          :image-arr="returnExchangeRecords.pictureCombination"
          class="m-t-10 p-x-0"
          :sign-width="80"
        ></three-image-post>
      </tk-card>
    </div>
    <!--物流名称·物流电话·物流与编号-->
    <div class="m-x-12 m-t-10 font-14" v-if="orderDetail && orderDetail.logisticsNumber">
      <tk-card :width="100" :height="50" is-middle class="p-y-8">
        <tk-flex middle between class="full-width">
          <div>物流名称</div>
          <div>{{orderDetail.logisticsName ? orderDetail.logisticsName : '空'}}</div>
        </tk-flex>
        <tk-flex middle between class="full-width m-t-10">
          <div>物流电话</div>
          <div v-if="orderDetail.phone">
            <a :href="`tel:${orderDetail.phone}`">{{ orderDetail.phone }}</a>
          </div>
        </tk-flex>
        <tk-flex middle between class="full-width m-t-10">
          <div>物流单号</div>
          <div
            :class="{ 'primary': orderDetail.copyLogisticsActive }"
            @click="copyReviewsOrder(orderDetail, orderDetail.logisticsNumber, '物流单号')"
          >{{orderDetail.logisticsNumber ? orderDetail.logisticsNumber : '空'}}</div>
        </tk-flex>
        <tk-flex middle between class="full-width m-t-10">
          <div>到付运费</div>
          <div>{{orderDetail.logisticsFreight || 0}}</div>
        </tk-flex>
      </tk-card>
    </div>
    <!--订单编号·下单时间-->
    <div class="m-x-12 m-t-10 font-14" v-if="orderDetail">
      <tk-card :width="100" :height="50" is-middle class="p-y-8">
        <tk-flex middle between class="full-width">
          <div>订单编号</div>
          <div
            :class="{ 'primary': orderDetail.copyActive }"
            @click="copyReviewsOrder(orderDetail, orderDetail.orderId, '订单编号')">{{orderDetail.orderId ? orderDetail.orderId : ''}}</div>
        </tk-flex>
        <tk-flex middle between class="full-width m-t-10">
          <div>下单时间</div>
          <div v-if="orderDetail.createdAt">{{orderDetail.createdAt | datetime}}</div>
        </tk-flex>
      </tk-card>
    </div>
    <!--支付方式·商品总额-->
    <div class="m-x-12 m-t-10 font-14" v-if="orderDetail">
      <tk-card :width="100" :height="30" is-middle class="p-y-8">
        <tk-flex middle between class="full-width" v-if="orderDetail.payMethod">
          <div>支付方式</div>
          <div>{{orderDetail.payMethod | payFormate}}</div>
        </tk-flex>
        <tk-flex between
                 middle
                 class="full-width"
                 :class="{'m-t-10': orderDetail.payMethod}"
        >
          <div>商品总额</div>
          <div v-if="orderDetail.orderAmount">{{orderDetail.orderAmount}}</div>
        </tk-flex>
      </tk-card>
    </div>
    <!--已付款订单发货框-->
    <tk-cover
      :show.sync="isEnterLogistics"
      center
      :hideOnClick="false"
    >
      <card
        :width="70" :height="50"
        class="p-0"
        style="position: relative;"
      >
        <!--关闭弹框-->
        <div class="cover-close" @click="isEnterLogistics = false">
          <tk-icon color="#fff" size="24">delete</tk-icon>
        </div>
        <tk-image :src="logisticsImage" height="60" style="width: 100%;"></tk-image>
        <div class="m-x-20 m-b-20">
          <tkui-simple-input class="logistics-input m-t-20" type="text" v-model="logisticsName" place-holder="物流名称">
          </tkui-simple-input>
          <tkui-simple-input class="logistics-input m-t-20" type="tel" v-model="phone" place-holder="物流电话">
          </tkui-simple-input>
          <tkui-simple-input class="logistics-input m-t-20" type="text" v-model="logisticsNumber" place-holder="物流单号">
          </tkui-simple-input>
          <tkui-simple-input class="logistics-input m-t-20" type="number" v-model="logisticsFreight" place-holder="到付运费">
          </tkui-simple-input>
          <tk-flex center class="m-t-20">
            <tkui-button @click="enterShip" class="small danger raised rounded logistics-btn">提交</tkui-button>
          </tk-flex>
        </div>
      </card>
    </tk-cover>
    <!--支付选择弹框-->
    <tk-cover
      :show.sync="isSelectedPay"
      center
      :hideOnClick="false"
    >
      <tk-card
        :height="50"
        :width="70"
        :is-middle="true"
        style="position: relative;"
      >
        <!--关闭弹框-->
        <div class="cover-close" @click="isSelectedPay = false">
          <tk-icon color="#fff" size="24">delete</tk-icon>
        </div>
        <tk-flex
          between middle
          @click.native="selectedChannel(index)"
          class="font-14 full-width"
          v-for="(s, index) in payList"
          :class="{'m-t-15': index !== 0}"
          :key="index"
        >
          <div>
            <tk-icon size="22">{{s.icon}}</tk-icon>
            <span class="m-l-12">{{s.text}}</span>
          </div>
          <tkui-toggle type="round" v-model="s.isSelected"></tkui-toggle>
        </tk-flex>
        <tk-flex center class="m-t-15 full-width">
          <action-button
            is-border :btn-text="'去支付'"
            :bd-color="'#D84342'" :text-color="'#CF1613'"
            :min-width="180" :is-raised="false" is-rounded
            @click.native="payOrder"
          ></action-button>
        </tk-flex>
      </tk-card>
    </tk-cover>
    <!--底部间隔-->
    <div style="height: 10px;"></div>
    <!--footer底部-->
    <footer
      slot="footer"
      style="border-top: 1px solid #f5f5f5;"
    >
      <card :height="0" :width="100" class="p-0" v-if="orderDetail">
        <!--我的订单按钮-->
        <tk-flex right class="p-r-5" v-if="$route.query.type === 'myOrder'">
          <action-button
            class="m-10"
            is-border :btn-text="'取消订单'"
            :bd-color="'#999'" :text-color="'#666'"
            :min-width="84" :is-raised="false" is-rounded
            v-if="orderDetail.status === 'pendingPayment'"
            @click.native.stop="cancelOrder"
          ></action-button>
          <action-button
            class="m-10"
            is-border :btn-text="'申请退换'"
            :bd-color="'#999'" :text-color="'#666'"
            :min-width="84" :is-raised="false" is-rounded
            v-if="orderDetail.status === 'toBeEvaluated' && !orderDetail.isApplyReturn"
            @click.native.stop="submitReturn"
          ></action-button>
          <action-button
            class="m-10"
            is-border :btn-text="'取消申请'"
            :bd-color="'#999'" :text-color="'#666'"
            :min-width="84" :is-raised="false" is-rounded
            v-if="orderDetail.status === 'returnExchange'"
            @click.native.stop="cancelSubmit"
          ></action-button>
          <action-button
            class="m-10"
            :btn-text="'立即付款'" :bg-color="'#D84342'"
            :bd-color="'#D84342'" :text-color="'#fff'"
            :min-width="84" is-raised is-rounded
            v-if="orderDetail.status === 'pendingPayment'"
            @click.native.stop="immediatelyPay"
          ></action-button>
          <action-button
            class="m-10"
            :btn-text="'立即评价'" :bg-color="'#D84342'"
            :bd-color="'#D84342'" :text-color="'#fff'"
            :min-width="84" is-raised is-rounded
            v-if="orderDetail.status === 'toBeEvaluated'"
            @click.native.stop="immediatelyEvaluated"
          ></action-button>
          <action-button
            class="m-10"
            :btn-text="'确认收货'" :bg-color="'#D84342'"
            :bd-color="'#D84342'" :text-color="'#fff'"
            :min-width="84" is-raised is-rounded
            v-if="orderDetail.status === 'pendingReceipt'"
            @click.native.stop="isShowReceipt = true"
          ></action-button>
        </tk-flex>
        <!--客户订单按钮-->
        <tk-flex right v-else>
          <action-button
            class="m-10"
            :btn-text="'立即发货'" :bg-color="'#D84342'"
            :bd-color="'#D84342'" :text-color="'#fff'"
            :min-width="84" is-raised is-rounded
            v-if="orderDetail.status === 'toBeShipped'"
            @click.native.stop="immediatelyShip"
          ></action-button>
          <action-button
            class="m-10"
            :btn-text="'确认退换'" :bg-color="'#D84342'"
            :bd-color="'#D84342'" :text-color="'#fff'"
            :min-width="84" is-raised is-rounded
            v-if="orderDetail.status === 'returnExchange'"
            @click.native.stop="sureReturnExchange"
          ></action-button>
        </tk-flex>
        <!--立即回复按钮-->
        <tk-flex right
                 v-if="orderDetail.status === 'completed'">
          <action-button
            class="m-y-10 m-l-10 m-r-15"
            :btn-text="'立即回复'" :bg-color="'#D84342'"
            :bd-color="'#D84342'" :text-color="'#fff'"
            :min-width="84" is-raised is-rounded
            v-show="!isCommentsShow"
            @click.native="isCommentsShow = true"
          ></action-button>
        </tk-flex>
        <!--输入框-->
        <div
          class="comments"
          v-show="isCommentsShow"
        >
          <tk-flex bottom gutter="5">
            <tk-flex class="comments-bg">
            <textarea-autosize
            ref="textarea"
            :placeholder="'想说点什么'"
            @focus.native.prevent="getOnBlur()"
            @blur.native.prevent="getBlur()"
            style="padding-left: 7px;"
            class="comments-area fill p-y-5 p-r-4"
            name="opinion"
            id="postsTextarea"
            cols="40" rows="1"
            v-model="commentsContent"
            :min-height="32"
            :max-height="350"
          ></textarea-autosize>
            </tk-flex>
            <div class="comments-btn m-t-2 text-right">
              <tkui-button @click="enterComments" :disabled="!commentsContent" class="comments-btn-enter primary small raised">发送</tkui-button>
            </div>
          </tk-flex>
        </div>
      </card>
    </footer>
    <!--确认收货弹框-->
    <tkui-dialog :show.sync="isShowReceipt" center>
      <div class="subhead">
        您确定要确认收货吗？
      </div>
      <template slot="action">
        <button class="tkui-dialog-button" @click="isShowReceipt = false">取消</button>
        <button class="tkui-dialog-button primary" @click="immediatelyReceipt">确定</button>
      </template>
    </tkui-dialog>
    <!--删除评论弹框-->
    <tk-cover
      :show.sync="isShowTouch"
      :color="'rgba(255, 255, 255, 0)'"
      transition
    >
      <tk-flex
        middle
        column
        class="posts-detail-delete"
        :style="{ left: clientLeft - 32 + 'px', top: clientTop - 118 + 'px' }"
      >
        <div class="font-14 text-gray" @click="copyReviews()">复制</div>
        <div style="margin-top: 35px;" class="text-gray font-14" @click="deleteSelfReplytoe()">删除</div>
      </tk-flex>
    </tk-cover>
  </tk-container>
</template>

<script>
import threeImagePost from '@/components/threeImagePost'
import orderCommodityData from '@/components/orderCommodityData'
import { Rate } from 'vant'
import { payMoney, getJobOrder } from '@/assets/help/tool'
const copy = require('clipboard-copy')
const logisticsImage = 'https://s3.moke.cloud/dianpei/68330568-74ca-4db5-a2ba-85aed5bc44cc.png'
export default {
  components: {
    threeImagePost,
    orderCommodityData,
    [Rate.name]: Rate
  },
  data () {
    return {
      status: 'loading', // 页面状态
      isHeaderColor: false, // 判断头部颜色切换
      logisticsImage: logisticsImage, // 物流输入框图片
      isEnterLogistics: false, // 物流输入框状态
      isCommentsShow: false, // 输入框显示状态
      isSelectedPay: false, // 是否选择支付
      settlementDisabled: false, // 支付状态
      isShowReceipt: false, // 是否确认收货
      selectedShip: null, // 选中要发货的数据
      orderDetail: null, // 订单详情
      returnExchangeRecords: null, // 订单退换货记录
      orderEvaluationRecords: null, // 订单评价记录
      logisticsName: '', // 物流名称
      phone: '', // 物流电话
      logisticsNumber: '', // 物流单号
      logisticsFreight: '', // 物流运费
      payChannel: 'ALI_APP', // 选定的支付通道
      payList: [ // 支付方式
        {
          icon: 'alipay',
          text: '支付宝',
          payChannel: 'ALI_APP',
          isSelected: true
        }, {
          icon: 'wechat',
          text: '微信',
          payChannel: 'WX_APP',
          isSelected: false
        }
      ],
      commentsContent: '', // 评论的内容
      deleteRender: {
        recipient: {},
        data: {},
        index: 0
      },
      enterLoading: false, //
      isShowTouch: false, // 长按后的的弹框
      timeOutEvent: 0, // 长按延时器定义
      clientTop: 0, // 弹框位置
      clientLeft: 0 // 弹框位置
    }
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.focus()
      },
      componentUpdated: function (el) {
        el.focus()
      }
    }
  },
  filters: {
    payFormate (val) {
      if (!val) return ''
      if (val === 'ALI_APP') { return '支付宝' }
      if (val === 'WX_APP') { return '微信' }
    },
    returnExchangeText (val) {
      return val === 'return' ? '退货' : '换货'
    },
    returnExchangeApply (val) {
      if (!val) return ''
      if (val === 'submitted') { return '已提交' }
      if (val === 'approved') { return '已同意' }
      if (val === 'rejected') { return '已拒绝' }
    }
  },
  computed: {
    // 县代账号购买商品送欢乐豆
    orderHappyBeanSum () {
      if (!this.userInfo.accountCategory) { return 0 }
      if (this.userInfo.accountCategory !== 'countyAccount') { return 0 }
      if (this.levelName === 'registeredMember' || this.levelName === 'bronzeMember') { return 50 }
      if (this.levelName === 'silverMembers') { return 100 }
      if (this.levelName === 'goldMembers') { return 150 }
      if (this.levelName === 'diamondMembers') { return 200 }
      return 0
    }
  },
  activated () {
    this.setStatusBar('light')
  },
  mounted () {
    this.getInit()
  },
  beforeRouteLeave (to, from, next) {
    this.setStatusBar('dark')
    this.clearSelector()
    next(true)
  },
  methods: {
    /**
     * 初始化数据
     * @date: 2020/4/1
     */
    async getInit () {
      try {
        await this.getOrderDetail() // 获取订单详情
        await this.getReturnExchangeRecords()// 获取该订单退换货信息
        await this.getOrderEvaluation()// 获取该订单评价信息
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    },
    /**
     * 复制订单编号
     * @date: 2020/10/27
     */
    copyReviewsOrder (s, content, text) {
      if (!s) { return }
      if (s.logisticsNumber === content) {
        s.copyLogisticsActive = true
      } else {
        s.copyActive = true
      }
      copy(content).then(e => {
        this.$tkGlobal.toast.add(`${text}已复制`)
        setTimeout(() => {
          s.copyActive = false
          s.copyLogisticsActive = false
          this.$forceUpdate()
        }, 500)
      }).catch(e => {
        s.copyActive = false
        s.copyLogisticsActive = false
        this.$tkGlobal.toast.add(`${text}复制失败`)
        this.$forceUpdate()
      })
      this.$forceUpdate()
    },
    /**
     * 清除选中
     * @date: 2020/8/28
     */
    clearSelector () {
      if (window.getSelection()) {
        const selection = window.getSelection()
        selection.removeAllRanges()
      } else if (document.selection && document.selection.empty) {
        document.selection.empty()
        // document.selection.clear()
      }
    },
    /**
     * 监听页面滚动改变头部背景颜色
     * @date: 2020/3/26
     */
    watchScroll (scrollTop) {
      this.isHeaderColor = scrollTop > 12
      this.setStatusBar(this.isHeaderColor ? 'dark' : 'light')
      this.$forceUpdate()
    },
    /**
     * 方法替换filters
     * @date: 2020/6/5
     */
    orderStatus (val) {
      if (!val) return ''
      if (val === 'cancelled') { return '已取消' }
      if (val === 'completed') { return this.$route.query.type !== 'myOrder' ? '已评价' : '已完成' }
      if (val === 'toBeShipped') { return '待发货' }
      if (val === 'toBeEvaluated') { return '待评价' }
      if (val === 'pendingPayment') { return '待付款' }
      if (val === 'pendingReceipt') { return this.$route.query.type !== 'myOrder' ? '已发货' : '待收货' }
      if (val === 'returnExchange') { return '退换货' }
    },
    /**
     * @Description: 获取订单详情
     * @author xiaozan
     * @date 2020/5/3
     */
    async getOrderDetail () {
      if (!this.$route.query.id) { return }
      let res = await this.$tkParse.getList('/classes/order', {
        params: {
          limit: 1,
          include: ['shippingAddress', 'merchants', 'buyUser'],
          where: {
            objectId: this.$route.query.id
          }
        }
      })
      if (res.length) {
        this.orderDetail = res[0]
        this.orderDetail.copyLogisticsActive = false
        this.orderDetail.copyActive = false
      } else { this.orderDetail = null }
      console.log(this.orderDetail)
    },
    /**
     * @Description: 获取订单退换货信息
     * @author xiaozan
     * @date 2020/5/3
     */
    async getReturnExchangeRecords () {
      if (!this.$route.query.id) { return }
      let res = await this.$tkParse.getList(`/classes/returnExchangeRecords`, {
        params: {
          limit: 1,
          order: '-createdAt',
          where: {
            order: this.$route.query.id,
            user: this.orderDetail.buyUser.objectId
          }
        }
      })
      if (res.length) { this.returnExchangeRecords = res[0] } else { this.returnExchangeRecords = null }
    },
    /**
     * @Description: 获取订单退换货信息
     * @author xiaozan
     * @date 2020/5/3
     */
    async getOrderEvaluation () {
      if (!this.$route.query.id) { return }
      let res = await this.$tkParse.getList(`/classes/orderEvaluation`, {
        params: {
          limit: 1,
          order: '-createdAt',
          where: {
            order: this.$route.query.id,
            buyUser: this.orderDetail.buyUser.objectId
          }
        }
      })
      if (res.length) {
        this.orderEvaluationRecords = res[0]
      } else {
        this.orderEvaluationRecords = null
      }
    },
    /**
     * @Description: 我的订单 取消订单
     * @author xiaozan
     * @date 2020/5/4
     */
    async cancelOrder () {
      let sum = await this.statisticsNum('order', { status: 'cancelled', objectId: this.orderDetail.objectId })
      let judgeOrder = await this.judgeId(this.orderDetail.objectId, 'order')
      if ((sum > 0 && judgeOrder) || !judgeOrder) {
        this.orderDetail.status = 'cancelled'
        this.$forceUpdate()
        return this.$tkGlobal.toast.add('订单已经取消过了')
      }
      this.status = 'waiting'
      await this.$cloudAjax.post('/orderActions/$cancelOrder', {
        orderId: this.orderDetail.objectId,
        userId: this.userInfo.objectId
      }).catch(e => {
        this.status = false
        throw this.$tkGlobal.toast.add(e.data ? e.data : '订单取消失败，如有需要请联系客服')
      })
      this.orderDetail.status = 'cancelled'
      this.$setFlash('orderEdit', { id: this.orderDetail.objectId, status: this.orderDetail.status })
      this.$tkGlobal.toast.add('订单取消成功')
      this.$forceUpdate()
      this.status = false
    },
    /**
     * @Description: 我的订单 申请退换
     * @author xiaozan
     * @date 2020/5/4
     */
    async submitReturn () {
      let sum = await this.statisticsNum('returnExchangeRecords',
        { order: this.orderDetail.objectId, user: this.orderDetail.buyUser.objectId })
      if (sum > 0) {
        this.orderDetail.status = 'returnExchange'
        this.orderDetail.isApplyReturn = true
        this.$forceUpdate()
        return this.$tkGlobal.toast.add('请勿重复提交')
      }
      this.$push({ path: '/order/applyReturn', query: { id: this.orderDetail.objectId } })
    },
    /**
     * @Description: 我的订单 取消申请
     * @author xiaozan
     * @date 2020/5/4
     */
    async cancelSubmit () {
      let sum = await this.statisticsNum('returnExchangeRecords',
        { user: this.orderDetail.buyUser.objectId, order: this.orderDetail.objectId })
      if (sum === 0) {
        this.orderDetail.status = 'toBeEvaluated'
        this.orderDetail.isApplyReturn = false
        this.$forceUpdate()
        return this.$tkGlobal.toast.add('请勿重复取消')
      }
      let submitSum = await this.statisticsNum('returnExchangeRecords',
        { user: this.orderDetail.buyUser.objectId, order: this.orderDetail.objectId, status: { $ne: 'submitted' } })
      if (submitSum > 0) {
        this.orderDetail.status = 'toBeEvaluated'
        await this.getReturnExchangeRecords()
        this.$forceUpdate()
        return this.$tkGlobal.toast.add('退换货申请状态已改变')
      }
      await this.$tkParse.delete(`/classes/returnExchangeRecords/${this.returnExchangeRecords.objectId}`)
      await this.$tkParse.put(`/classes/order/${this.orderDetail.objectId}`, {
        status: 'toBeEvaluated',
        isApplyReturn: false
      })
      await this.getReturnExchangeRecords()
      this.orderDetail.status = 'toBeEvaluated'
      this.$setFlash('orderEdit', { id: this.orderDetail.objectId, status: this.orderDetail.status })
      this.orderDetail.isApplyReturn = false
      this.$tkGlobal.toast.add('您成功取消了退换货申请')
    },
    /**
     * @Description: 付款
     * @author xiaozan
     * @date 2020/5/5
     */
    async payOrder () {
      this.isSelectedPay = false
      this.status = 'waiting'
      this.$tkHistory.disable()
      if (this.settlementDisabled) { return }
      // 准备给云接口传参数 userId, selectedProductsData, merchants, discountOrderAmount, payChannel, orderId
      let orderObj = {
        userId: this.userInfo.objectId, // 用户的id
        selectedProductsData: [this.orderDetail], // 选定要结算的数据
        merchants: this.orderDetail.merchants.objectId, // 商户id
        discountOrderAmount: this.orderDetail.orderAmount, // 结算的金额
        orderId: this.orderDetail.objectId, // 结算的订单id
        payChannel: this.payChannel // 选定的支付方式
      }
      // 支付订单
      let payStatus = await payMoney(this.orderDetail.objectId, this.orderDetail.orderAmount, 'WX_APP')
      if (!payStatus) {
        this.status = false
        this.$tkHistory.enable()
        this.settlementDisabled = false
        this.$tkGlobal.toast.add('付款失败')
        return
      }
      // 支付成功以后·修改待付款订单为已付款·修改商品销量 如果为限时抢购商品减库存· 跳转支付成功页面
      if (orderObj.discountOrderAmount === 0) {
        orderObj.trade_success = true
        await this.$cloudAjax.post('/wxpay/$payOrder', orderObj).catch(e => {
          this.status = false
          this.$tkHistory.enable()
          this.settlementDisabled = false
          throw this.$tkGlobal.toast.add(e.data ? e.data : '付款失败，请联系客服')
        })
      }
      this.orderDetail.status = 'toBeShipped'
      this.$setFlash('orderEdit', { id: this.orderDetail.objectId, status: this.orderDetail.status })
      this.$tkGlobal.toast.add('付款成功')
      this.$push({ path: '/order/paySuccess', query: { id: this.orderDetail.objectId } })
      await this.$tkHelper.sleep(500)
      this.status = false
      this.$tkHistory.enable()
      this.settlementDisabled = false
    },
    /**
     * @Description: 我的订单 立即付款
     * @author xiaozan
     * @date 2020/5/4
     */
    immediatelyPay () {
      // this.isSelectedPay = true
      this.payOrder()
    },
    /**
     * @Description: 我的订单 立即评价
     * @author xiaozan
     * @date 2020/5/4
     */
    async immediatelyEvaluated () {
      let sum = await this.statisticsNum('order',
        { status: 'completed', objectId: this.orderDetail.objectId })
      if (sum > 0) {
        this.orderDetail.status = 'completed'
        this.$forceUpdate()
        return this.$tkGlobal.toast.add('该订单已经评价了')
      }
      this.$push({ path: '/order/toEvaluatedPage', query: { id: this.orderDetail.objectId } })
    },
    /**
     * @Description: 我的订单 确定收货
     * @author xiaozan
     * @date 2020/5/4
     */
    async immediatelyReceipt () {
      let sum = await this.statisticsNum('order', { status: 'toBeEvaluated', objectId: this.orderDetail.objectId })
      if (sum > 0) {
        this.orderDetail.status = 'toBeEvaluated'
        this.$forceUpdate()
        this.isShowReceipt = false
        return this.$tkGlobal.toast.add('该订单已经收过货了')
      }
      // 删除任务列表中对应任务
      let res = await getJobOrder('sureReceipt', this.orderDetail.objectId)
      if (res.length) {
        await this.$tkParse.delete(`/classes/scheduleJob/${res[0].objectId}`)
      }
      // 确认收货
      await this.$tkParse.put(`/classes/order/${this.orderDetail.objectId}`, {
        status: 'toBeEvaluated'
      }).catch(e => {
        throw this.$tkGlobal.toast.add('收货失败')
      })
      await this.getOrderDetail()
      this.$setFlash('orderEdit', { id: this.orderDetail.objectId, status: this.orderDetail.status })
      this.$tkGlobal.toast.add('确认收货提交成功')
      this.isShowReceipt = false
    },
    /**
     * @Description: 客户订单 立即发货
     * @author xiaozan
     * @date 2020/5/4
     */
    async immediatelyShip () {
      let sum = await this.statisticsNum('order', { status: 'pendingReceipt', objectId: this.orderDetail.objectId })
      if (sum > 0) {
        this.orderDetail.status = 'pendingReceipt'
        this.$forceUpdate()
        return this.$tkGlobal.toast.add('该订单已经发过货了')
      }
      this.isEnterLogistics = true
    },
    /**
     * @Description: 客户订单 确定退换
     * @author xiaozan
     * @date 2020/5/4
     */
    async sureReturnExchange () {
      let sum = await this.statisticsNum('returnExchangeRecords',
        { user: this.orderDetail.buyUser.objectId, order: this.orderDetail.objectId })
      if (sum === 0) {
        this.orderDetail.status = 'toBeEvaluated'
        this.orderDetail.isApplyReturn = false
        this.$forceUpdate()
        return this.$tkGlobal.toast.add('用户申请已取消')
      }
      let submitSum = await this.statisticsNum('returnExchangeRecords',
        { user: this.orderDetail.buyUser.objectId, order: this.orderDetail.objectId, status: { $ne: 'submitted' } })
      if (submitSum > 0) {
        this.orderDetail.status = 'toBeEvaluated'
        await this.getReturnExchangeRecords()
        this.$forceUpdate()
        return this.$tkGlobal.toast.add('您已经确定退换了')
      }
      await this.$tkParse.put(`/classes/returnExchangeRecords/${this.returnExchangeRecords.objectId}`, {
        status: 'approved'
      })
      await this.$tkParse.put(`/classes/order/${this.orderDetail.objectId}`, {
        status: 'toBeEvaluated'
      })
      await this.getReturnExchangeRecords()
      this.orderDetail.status = 'toBeEvaluated'
      this.$setFlash('orderEdit', { id: this.orderDetail.objectId, status: this.orderDetail.status })
      this.$tkGlobal.toast.add('您同意了用户的退换货申请')
    },
    /**
     * 选定支付方式
     * @date: 2020/4/28
     */
    selectedChannel (index) {
      this.payList.forEach(s => { s.isSelected = false })
      this.payList[index].isSelected = true
      this.payChannel = this.payList[index].payChannel
    },
    /**
     * @Description: 发货
     * @author xiaozan
     * @date 2020/5/3
     */
    async enterShip () {
      if (!this.logisticsName || !this.phone || !this.logisticsNumber || !this.logisticsFreight) {
        return this.$tkGlobal.toast.add('发货信息不完整')
      }
      let orderObj = {
        logisticsName: this.logisticsName, // 物流名称
        phone: this.phone, // 物流电话
        logisticsNumber: this.logisticsNumber, // 物流单号
        logisticsFreight: Number(this.logisticsFreight), // 物流运费
        userId: this.userInfo.objectId, // 用户的id
        selectedShip: this.orderDetail // 发货的订单
      }
      await this.$cloudAjax.post('/orderActions/$enterShip', orderObj).catch(e => {
        this.selectedShip = null
        throw this.$tkGlobal.toast.add(e.data ? e.data : '发货失败')
      })
      await this.getOrderDetail()
      this.$setFlash('orderEdit', { id: this.orderDetail.objectId, status: this.orderDetail.status })
      this.$tkGlobal.toast.add('发货信息提交成功')
      this.isEnterLogistics = false
    },
    /**
     * 获取焦点
     * @date: 2020/4/11
     */
    getOnBlur () {
      this.isCommentsShow = true
    },
    /**
     * 失去焦点
     * @date: 2020/5/4
     */
    getBlur () {
      // this.isCommentsShow = false
    },
    /**
     * @Description: 发送评论信息
     * @author xiaozan
     * @date 2020/5/5
     */
    async enterComments () {
      if (!this.orderEvaluationRecords) { return this.$tkGlobal.toast.add('没有找到评价信息') }
      let isOrder = await this.judgeId(this.$route.query.id, 'order')
      if (!isOrder) { return this.$tkGlobal.toast.add('该订单已被删除') }
      if (!this.commentsContent) { return this.$tkGlobal.toast.add('回复内容不能为空') }
      // 获取最新的评价信息
      let res = await this.$tkParse.getList(`/classes/orderEvaluation`, {
        params: {
          limit: 1,
          order: '-createdAt',
          where: {
            order: this.$route.query.id,
            buyUser: this.orderDetail.buyUser.objectId
          }
        }
      })
      this.orderEvaluationRecords = res[0]
      // 获取服务器时间 即现在时间
      let nowTime = await this.$tkParse.getData(`https://api.mokekeji.com/time`)
      if (!this.orderEvaluationRecords.reviewsPostsList) { this.orderEvaluationRecords.reviewsPostsList = [] }
      this.orderEvaluationRecords.reviewsPostsList.push({
        isExpand: true,
        date: nowTime,
        reviewerContent: this.commentsContent,
        reviewer: this.userInfo
      })
      await this.$tkParse.put(`/classes/orderEvaluation/${this.orderEvaluationRecords.objectId}`, {
        reviewsPostsList: this.orderEvaluationRecords.reviewsPostsList
      }).catch(e => {
        this.isCommentsShow = false
        throw this.$tkGlobal.toast.add('信息发送失败')
      })
      this.$tkGlobal.toast.add('信息发送成功')
      this.commentsContent = ''
      this.isCommentsShow = false
      this.$forceUpdate()
    },
    /**
     * 长按操作
     * @date: 2020/8/21
     */
    gtouchstart (e, recipient, data, index) {
      this.timeOutEvent = setTimeout(() => {
        this.longPress(e, recipient, data, index)
      }, 100)
      return false
    },
    /**
     * 手释放，如果在500毫秒内就释放，则取消长按事件，此时可以执行onclick应该执行的事件
     * @date: 2020/8/21
     */
    gtouchend (recipient, data, s, index) {
      clearTimeout(this.timeOutEvent)// 清除定时器
      return false
    },
    /**
     * 如果手指有移动，则取消所有事件，此时说明用户只是要移动而不是长按
     * @date: 2020/8/21
     */
    gtouchmove () {
      clearTimeout(this.timeOutEvent) // 清除定时器
      this.timeOutEvent = 0
    },
    /**
     * 真正长按后应该执行的内容
     * @date: 2020/8/21
     */
    longPress (e, recipient, data, index) {
      if (recipient.objectId !== this.userInfo.objectId) {
        return
      }
      this.deleteRender = {
        recipient: {},
        data: {},
        index: 0
      }
      this.timeOutEvent = 0
      // 执行长按要执行的内容，如弹出菜单
      this.deleteRender = {
        recipient: recipient,
        data: data,
        index: index
      }
      this.clientTop = e.changedTouches['0'].clientY
      this.clientLeft = e.changedTouches['0'].clientX
      this.isShowTouch = true
    },
    /**
     * 删除自己跟帖评论或回复评论人
     * @date: 2020/8/20
     */
    async deleteSelfReplytoe () {
      let recipient = this.deleteRender.recipient
      let index = this.deleteRender.index
      this.isShowTouch = false
      if (recipient.objectId !== this.userInfo.objectId) { return }
      await this.subDelEnter(index)
    },
    /**
     * 删除跟帖评论
     * @date: 2020/8/20
     */
    async subDelEnter (index) {
      if (this.enterLoading) {
        return this.$tkGlobal.toast.add('您点的太快了')
      }
      if (!this.orderEvaluationRecords.reviewsPostsList[index]) {
        return this.$tkGlobal.toast.add('未找到该评论信息')
      }
      this.enterLoading = true
      this.orderEvaluationRecords.reviewsPostsList.splice(index, 1)
      await this.$tkParse.put(`/classes/orderEvaluation/${this.orderEvaluationRecords.objectId}`, {
        reviewsPostsList: this.orderEvaluationRecords.reviewsPostsList
      }).catch(e => {
        this.enterLoading = false
        throw this.$tkGlobal.toast.add('删除订单评论失败')
      })
      // 更新页面
      this.$tkGlobal.toast.add('订单评论删除成功')
      await this.$tkHelper.sleep(500)
      this.enterLoading = false
      this.$forceUpdate()
    },
    /**
     * 复制评论
     * @date: 2020/8/21
     */
    copyReviews () {
      copy(this.deleteRender.data.reviewerContent).then(s => {
        this.isShowTouch = false
        this.$tkGlobal.toast.add('复制评论成功')
      }).catch(e => {
        this.$tkGlobal.toast.add('复制评论失败')
      })
    }
  },
  hasFlash () {
    let orderEdit = this.$getFlash('orderEdit')
    if (orderEdit) {
      if (orderEdit.id === this.orderDetail.objectId) {
        this.orderDetail.status = orderEdit.status
      }
    }
  }
}
</script>

<style scoped lang="scss">
  /*头部样式*/
  .header-editor {
    width: 60px;
    height: 30px;
    line-height: 30px;
  }
  .order-detail-bg {
    background-repeat: no-repeat !important;
    background-size: 100% 180px !important;
    min-height: 50px;
    background-attachment: fixed !important;
  }
  /*后台数据渲染样式*/
  .content-box {
    /*background-position: center center;*/
    padding-top: 70px;
    .card-address {
      width: 100%;
      min-height: 85px;
      background: #fff;
      padding: 15px;
      border-radius: 5px;
    }
  }
  /*评论样式*/
  .posts-card-footer {
    width: 100%;
    min-height: 50px;
    background:rgba(247,247,247,1);
    border-top: 1px solid #fff;
    border-radius: 5px;
    .posts-card-footer-bottom-tips {
      color: rgba(91, 108, 143, 1);
    }
    .posts-card-footer-bottom-color {
      font-size: 13px;
      color: rgba(91, 108, 143, 1);
      word-break: break-all;white-space: normal;
    }
    .posts-card-footer-bottom-active {
      background: #bababa !important;
    }
    .posts-card-footer-bottom-radius {
      border-radius: 0 0 5px 5px;
    }
  }
  /*发货框样式*/
  .cover-close {
    position: absolute;
    top: -45px;
    z-index: 1;
    right: 0;
  }
  .logistics-input {
    width: 100%;
    height: 40px;
    background-color: rgba(245, 245, 245, 1);
    border-radius: 20px;
    padding-left: 10px;
  }
  .logistics-input::placeholder  {
    font-size: 13px;
    color: rgba(153, 153, 153, 1);
  }
  .logistics-btn {
    margin: 0 auto;
    width: 115px;
    height: 32px;
    border-radius: 16px;
    background: #F7B43B !important;
  }
  /*底部样式*/
  .settlement-btn {
    width: 85px;
    height: 36px;
    background:linear-gradient(90deg,rgba(248,69,39,1),rgba(207,22,19,1));
    border-radius: 18px;
    margin: 0;
  }
  /*删除评论弹框样式*/
  .posts-detail-delete {
    position: absolute;
    background: #fff;
    width: 75px;
    height: 110px;
    color: #000;
    padding-left: 15px;
    border-radius: 2px;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16);
  }
  /*输入框样式*/
  .comments {
    background-color: #ffffff;
    min-height: 38px;
    padding: 7px 12px 7px 12px;
    .comments-bg {
      width: 78%;
      position: relative;
      border-radius: 5px;
      background-color: #f8f6f8;
    }
    .comments-btn {
      .comments-btn-enter {
        border-radius: 5px;
        border: 1px solid #dad8d8;
        margin: 0;
        height: 32px;
      }
    }
    .comments-area {
      height: 100%;
      width: 100px;
      min-width: 0;
      overflow-y: auto;
      resize: none;
    }
    .comments-area::placeholder {
      font-size: 14px;
      color: rgba(153, 153, 153, 1);
    }
    .comments-favorite {
      font-size: 10px !important;
    }
    ::v-deep .tkui-button.disabled {
      background: #f8f6f8 !important;
      opacity: 1 !important;
      color: #d6d3d6 !important;
    }
  }
</style>
